import { Collapse, Tabs, message } from "antd";
import { useEffect, useState, useMemo } from "react";
const { Panel } = Collapse;
import { Table } from "antd";
import CreditReviewForm from "@/components/CreditReviewForm";
import Approvalform from "@/components/tabApproval";
import PhotoDocumentTab from "@/components/PhotoDocumentTab";
import ThumbnailGrid from "@/components/ThumbnailGrid";
import { useSearchParams } from "react-router-dom";
import { useParams } from "react-router-dom";
import { API, URL } from "@/config/api";

const DealerDetailPage = () => {
  const { id } = useParams();

  const [nikPasangan, setNikPasangan] = useState(null);
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);

  const [headerInfo, setHeaderInfo] = useState({});
  const [status, setStatus] = useState("-");
  const [activeKey, setActiveKey] = useState("1");

  const API_BASE_URL2 = import.meta.env.VITE_BASE_URL2; //3001
  const API_BASE_URL = import.meta.env.VITE_BASE_URL; //3000

  // const checkAndSetStatus = (result) => {
  //   let newStatus = "Credit Review";
  //   if (result.credit_review && Object.keys(result.credit_review).length > 0)
  //     newStatus = "Approval 1";
  //   if (result.approval1 && Object.keys(result.approval1).length > 0)
  //     newStatus = "Approval 2";
  //   if (result.approval2 && Object.keys(result.approval2).length > 0)
  //     newStatus = "Approval 3";
  //   if (result.approval3 && Object.keys(result.approval3).length > 0)
  //     newStatus = "Final Approved";
  //   setStatus(newStatus);
  // };

  const getData = async () => {
    try {
      setLoading(true);
      const response = await API.get(URL.MASTER_DEALER + "/" + id);
      const data = response?.data?.data;

      // console.log("data stataus =>", data.is_approved);

      // --- Untuk tujuan demonstrasi, saya gunakan data dummy ---
      // const data = {
      //   is_approved: true,
      //   application_id: "APP-12345",
      //   created_at: "2025-09-15T10:00:00Z",
      //   namadealer: "Dealer Sejahtera Motor",
      //   kantorcabang: "Cabang Jakarta Pusat",
      //   created_by: "John Doe",
      //   created_date: "2025-09-14",
      //   kddealer: "DLR001",
      //   alamatdealer: "Jl. Otomotif Raya No. 1",
      //   telpondealer: "021-555-1234",
      //   namapemilikdealer: "Budi Santoso",
      //   nohppemilik: "081234567890",
      //   picdealer: "Andi Wijaya",
      //   kondisikendaraan: "Baru",
      //   merkkendaraan: "Toyota",
      //   typekendaraan: "Avanza Veloz",
      //   tahunkendaraan: "2024",
      //   nopolisikendaraan: "B 1234 XYZ",
      //   hargakendaraan: "250000000",
      //   uangmuka: "50000000",
      //   pokokhutang: "200000000",
      // };

      setData(data);
      setHeaderInfo({
        application_no: data?.application_id || "-",
        application_date: data?.created_at?.split("T")[0] || "-",
        customer_name: data?.namadealer || "-",
        status:
          data?.is_approved === null ||
          data?.is_approved === [] ||
          data?.is_approved === "" ||
          data?.is_approved === undefined
            ? "Waiting"
            : data?.is_approved === true
            ? "Approved"
            : "Rejected",
        branch_name: data?.kantorcabang || "-",
        cmo: data?.created_by || "-",
        created_date: data?.created_date || "-",
      });
      setLoading(false);
    } catch (error) {
      message.error("Data failed to fetch!");
      setLoading(false);
    }
  };

  useEffect(() => {
    getData();

    // console.log(id);
    // console.log(data.status);

    setTimeout(() => {
      setLoading(false);
    }, 500);
  }, []);

  const mergeAlamatPemilik = (data) => {
    const addressParts = [];
    if (data.alamatpemilik) addressParts.push(data.alamatpemilik);

    if (data.rtpemilik || data.rwpemilik) {
      addressParts.push(
        `RT ${data.rtpemilik || "-"} / RW ${data.rwpemilik || "-"}`
      );
    }

    if (data.kelurahanpemilik)
      addressParts.push(`Kel. ${data.kelurahanpemilik}`);
    if (data.kecamatanpemilik)
      addressParts.push(`Kec. ${data.kecamatanpemilik}`);
    if (data.kotapemilik) addressParts.push(data.kotapemilik);
    if (data.provinsipemilik) addressParts.push(data.provinsipemilik);

    const alamatLengkap = addressParts.join(", ");
    return alamatLengkap;
  };

  const mergeAlamatPengelola = (data) => {
    const addressParts = [];
    if (data.alamatpengelola) addressParts.push(data.alamatpengelola);

    if (data.rtpengelola || data.rwpengelola) {
      addressParts.push(
        `RT ${data.rtpengelola || "-"} / RW ${data.rwpengelola || "-"}`
      );
    }

    if (data.kelurahanpengelola)
      addressParts.push(`Kel. ${data.kelurahanpengelola}`);
    if (data.kecamatanpengelola)
      addressParts.push(`Kec. ${data.kecamatanpengelola}`);
    if (data.kotapengelola) addressParts.push(data.kotapengelola);
    if (data.provinsipengelola) addressParts.push(data.provinsipengelola);

    const alamatLengkap = addressParts.join(", ");
    return alamatLengkap;
  };

  const formattedDataSections = useMemo(() => {
    if (!data) return {}; // Jika data belum ada, kembalikan objek kosong

    const alamatLengkap = mergeAlamatPemilik(data);
    const alamatLengkapPengelola = mergeAlamatPengelola(data);

    return {
      dealer: [
        { label: "Kode Dealer", value: data.kddealer },
        { label: "Nama Dealer", value: data.namadealer },
        { label: "Nama Brand Dealer", value: data.namabranddealer },
        { label: "Nama Group Dealer", value: data.namagroupdealer },
        { label: "Alamat Dealer", value: data.alamatdealer },
        { label: "Telpon Dealer", value: data.telpon },
        { label: "Handphone Dealer", value: data.nohpdealer },
        { label: "PIC Dealer", value: data.picdealer },
      ],
      pemilik: [
        { label: "Nama ", value: data.pemilik },
        { label: "Email", value: data.emailpemilik },
        { label: "Telepon", value: data.telponpemilik },
        { label: "No. Handphone", value: data.hp },
        { label: "Alamat Lengkap", value: alamatLengkap || "-" },
      ],
      pengelola: [
        { label: "Nama ", value: data.pengelola },
        { label: "Email", value: data.emailpengelola },
        { label: "Telepon", value: data.telponpengelola },
        { label: "No. Handphone", value: data.hppengelola },
        { label: "Alamat Lengkap", value: alamatLengkapPengelola || "-" },
      ],
      usaha: [
        { label: "Lama Usaha Dealer", value: data.lamausaha || "-" },
        {
          label: "Kepemilikan Tempat Usaha Dealer",
          value: data.statusmilikusaha || "-",
        },
        {
          label: "Jumlah Stok Kendaraan (Unit)",
          value: data.jumlahstok || "-",
        },
        {
          label: "Rata-rata Penjualan / Bulan (Unit)",
          value: data.ratapenjualan || "-",
        },
        {
          label: "Rata-rata Penjualan Kredit / Bulan (Unit)",
          value: data.ratapenjualankredit || "-",
        },
        {
          label: "Rata-rata Tahun Kendaraan",
          value: (data.ratatahunkendaraan || []).join(", ") || "-",
        },
        {
          label: "Rata-rata Harga OTR Kendaraan",
          value: (data.ratahargaotr || []).join(", ") || "-",
        },
        { label: "Omset Usaha / Bulan", value: data.omset || "-" },
        {
          label: "Kompetitor",
          value: (data.kompetitor || []).join(", ") || "-",
        },
        { label: "Jenis Dealer/Showroom", value: data.jenisdelaer || "-" },
      ],
      referensi: [
        { label: "Nama Dealer 1", value: data.namadealer1 || "-" },
        { label: "Alamat Dealer 1", value: data.alamatdealer1 || "-" },
        {
          label: "No. Telepon/Handphone Dealer 1",
          value: data.telpondealer1 || "-",
        },
        {
          label: "Nama Owner/Pengelola Dealer 1",
          value: data.ownerdealer1 || "-",
        },
        { label: "Nama Dealer 2", value: data.namadealer2 || "-" },
        { label: "Alamat Dealer 2", value: data.alamatdealer2 || "-" },
        {
          label: "No. Telepon/Handphone Dealer 2",
          value: data.telpondealer2 || "-",
        },
        {
          label: "Nama Owner/Pengelola Dealer 2",
          value: data.ownerdealer2 || "-",
        },
      ],
    };
  }, [data]);

  return (
    <div>
      {/* <h1 className="text-4xl font-semibold mb-8">APPROVAL DETAIL PAGE</h1> */}
      <h1 className="text-4xl font-semibold mb-8">APPROVAL DEALER PAGE</h1>
      <div className="p-4 bg-blue-50 border border-blue-100 shadow-sm rounded-xl mb-6">
        <div className="grid grid-cols-2 gap-x-8 gap-y-2">
          <div className="flex">
            <div className="w-1/2 text-sm text-gray-600">Application Id</div>
            <div className="w-1/2 text-sm font-semibold text-gray-800">
              {headerInfo.application_no}
            </div>
          </div>
          <div className="flex">
            <div className="w-1/2 text-sm text-gray-600">Nama Dealer</div>
            <div className="w-1/2 text-sm font-semibold text-gray-800">
              {headerInfo.customer_name}
            </div>
          </div>
          <div className="flex">
            <div className="w-1/2 text-sm text-gray-600">Application Date</div>
            <div className="w-1/2 text-sm font-semibold text-gray-800">
              {headerInfo.application_date}
            </div>
          </div>
          {/* <div className="flex">
          <div className="w-1/2 text-sm text-gray-600">Status</div>
          <div className="w-1/2 text-sm font-semibold text-gray-800">{headerInfo.status}</div>
        </div> */}

          {/* <div className="flex">
            <div className="w-1/2 text-sm text-gray-600">Status</div>
            <div className="w-1/2 text-sm font-semibold">
              {(() => {
                const statusLabelMap = {
                  CRA: "Credit Review Analis",
                  "APPV-1": "Approval 1",
                  "APPV-2": "Approval 2",
                  "APPV-3": "APPROVAL 3",
                  FA: "Final Approve",
                };

                const statusRaw = headerInfo?.status || "";
                const statusCleaned = statusRaw.replace(/\s+/g, "");
                const label = statusLabelMap[statusCleaned] || statusRaw;
                // const bgColor = statusColorMap[statusCleaned] || "#d9d9d9";
                // console.log("ini ktp pasangan bukan", pasangan.ktppasangan);

                // const [nikPasangan, setNikPasangan] = useState(null);

                // setNikPasangan(pasangan.nikpasangan || null);

                return (
                  <span
                    style={{
                      // backgroundColor: bgColor,
                      color: "#0a0a0a",
                      // padding: "4px 8px",
                      // borderRadius: "6px",
                      display: "inline-block",
                    }}
                  >
                    {label}
                  </span>
                );
              })()}
            </div>
          </div> */}

          <div className="flex">
            <div className="w-1/2 text-sm text-gray-600">STATUS</div>
            <div className="w-1/2 text-sm font-semibold text-gray-800">
              {headerInfo.status}
            </div>
          </div>
          <div className="flex">
            <div className="w-1/2 text-sm text-gray-600">NAMA CABANG</div>
            <div className="w-1/2 text-sm font-semibold text-gray-800">
              JAKARTA
            </div>
          </div>
          <div className="flex">
            <div className="w-1/2 text-sm text-gray-600">CMO </div>
            <div className="w-1/2 text-sm font-semibold text-gray-800">
              {headerInfo.cmo}
            </div>
          </div>
        </div>
      </div>

      <Collapse
        ghost
        // defaultActiveKey={Object.keys(formattedDataSections).map((_, index) =>
        //   String(index)
        // )}
        defaultActiveKey={["0", "1", "2", "3", "4", "5"]}
      >
        {Object.entries(formattedDataSections).map(
          ([panelKey, items], index) => {
            const isNotEmpty = items.some(
              (item) =>
                item.value !== null &&
                item.value !== undefined &&
                item.value !== ""
            );
            if (!isNotEmpty) return null;

            const titleMap = {
              dealer: "Informasi Dealer",
              pemilik: "Informasi Pemilik",
              pengelola: "Informasi Pengelola",
              usaha: "Informasi Usaha",
              referensi: "Referensi Dealer",
              // ... mapping judul lainnya
            };

            return (
              <Panel header={titleMap[panelKey] || panelKey} key={index}>
                <div className="p-4 bg-gray-50 border border-gray-200 shadow-sm rounded-xl mb-6">
                  <div className="grid grid-cols-2 gap-x-8 gap-y-3">
                    {items.map((item, idx) => (
                      <div key={idx} className="flex">
                        <div className="w-1/2 text-sm text-gray-600">
                          {item.label}
                        </div>
                        <div className="w-1/2 text-sm font-semibold text-gray-800">
                          {item.value || "-"}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </Panel>
            );
          }
        )}
      </Collapse>
    </div>
  );
};

export default DealerDetailPage;
